import { useState } from "react";
import { Link, Outlet } from "react-router-dom";
import { MainButtonInput } from "../../../mainComponent/mainButtonInput";
import AuthApi from "../../../services/AuthApi";
import { MainInput } from "../../../mainComponent/mainInput";
import { ShowCreateOtp } from "./showCreateOtp";

export default function CreateDoctorMpin() {
    //for show otp input
    const [mobile, setMobile] = useState("");
    const [loginData, setLoginData] = useState([]);
    const [isError, setIsError] = useState(false);
    const [message, setMessage] = useState(false)
    const [showOTP, setShowOTP] = useState(false);
    const { login } = AuthApi();

    const getOTPSection = (e) => {
        e.preventDefault()
        if (mobile.length < 10) {
            setIsError(true)
        }
        else {
            login({ mobile })
                .then(response => {
                    if (response.data.isLoggedIn !== true) {
                        alert(response.data.otp)
                        setShowOTP(true)
                        setMessage(true)
                        setIsError(false)
                    }
                    else {
                        setIsError('Mobile number already exist.')
                    }
                    let item = response.data
                    setLoginData(item)
                })
        }
    };

    return (
        <main>
            <div className="bg_color_2">
                <div className="container margin_60_35">
                    <div id="login-2">
                        <h1>Create Account</h1>
                        <form >
                            <div className="clearfix">
                                <div className="last">
                                    <div className="row">
                                        <lable className="mb-2 fontSize">Mobile Number</lable>
                                        <div className="col-md-12 mb-2">
                                            <input
                                                name="mobile"
                                                value={mobile.mobile}
                                                maxLength={10}
                                                pattern="[+-]?\d+(?:[.,]\d+)?"
                                                onChange={(e) => setMobile(e.target.value)}
                                                placeholder="Phone Number (+XX)"
                                                className="form-control"
                                            />
                                            <div className="mt-2" align='right'>
                                                {message && (<span className="sendotp-message"> OTP is sent to the mobile number</span>)}
                                            </div>
                                        </div>

                                        {showOTP === true ?
                                            <>
                                                <ShowCreateOtp loginData={loginData} />
                                                <Outlet />
                                            </>
                                            : <>
                                                <div className="mt-2" align='right'>
                                                    {message && (<span className="sendotp-message"> OTP is sent to the mobile number</span>)}
                                                </div>
                                                <div className="">
                                                    <MainButtonInput onClick={getOTPSection}>Go</MainButtonInput>
                                                </div>
                                            </>
                                        }
                                    </div>
                                    <div className="mt-2 validation">{isError}</div>
                                </div>
                            </div>
                        </form>
                        <div className=" appcolor" align="right">
                            <Link to='/'>Already have account </Link>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}